import React, { useState } from "react";
import axios from "axios";
import styles from "./ContactUsMain.module.css";
import API_BASE_URL from "../../config/api";

// icon image
import location from "../../Components/Assets/icon/contact_location.svg";
import googleLocation from "../../Components/Assets/icon/contact_googleLocation.svg";
import phone from "../../Components/Assets/icon/contact_phone.svg";
import customerService from "../../Components/Assets/icon/contact_customerService.svg";
import fax from "../../Components/Assets/icon/contact_fax.svg";
import email from "../../Components/Assets/icon/contact_email.svg";
import headerImg from "../../Components/Assets/pageHeaderImg/contact_header.jpg";

const ContactUsMain = () => {
  const [messageVisible, setMessageVisible] = useState(false); // success message visibility

  const [formData, setFormData] = useState({
    title: "Mr",
    fullName: "",
    contactNumber: "",
    email: "",
    state: "",
    postcode: "",
    inquiryType: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/handleContactSubmission.php`, formData);
      setMessageVisible(true);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Form submission error:", error.response || error);
      alert("Failed to submit. Please try again.");
    }
  };

  return (
    <div>
      <img className={styles.headerImg} src={headerImg} alt="" />

      <div className={styles.contactContainer}>
        <div className={styles.companyInfo}>
          <h2>Bodyfriend Malaysia HQ</h2>

          {/* address */}
          <div className={styles.company1}>
            <div className={styles.info_detail}>
              <img src={location} alt="" />
              <p>
                <strong>HEALTHY WORLD LIFESTYLE SDN. BHD. (550497-K)</strong>
                <br></br>
                No. 22, Jalan Anggerik Mokara 31/47, <br></br>
                Kota Kemuning, 40460 Shah Alam, <br></br>
                Selangor Darul Ehsan, Malaysia.
              </p>
            </div>
            <div className={styles.maps}>
              <a
                href="https://www.google.com/maps/place/OGAWA+Malaysia+-+Healthy+World+Lifestyle+Sdn.+Bhd./@2.986191,101.5442457,17z/data=!3m1!4b1!4m6!3m5!1s0x31cdb214c71370e3:0xd55663dff935469!8m2!3d2.986191!4d101.5442457!16s%2Fg%2F1tj43dlw?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoJLDEwMjExMjM0SAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={googleLocation} alt="" />
                <span>Google Maps</span>
              </a>
            </div>
          </div>

          {/* phone */}
          <div className={styles.info_detail}>
            <img src={phone} alt="" />
            <p>
              <strong>Phone</strong>
              <br></br>
              +603-5121 4286 <br></br>
              +603-5125 1600
            </p>
          </div>

          {/* customer service */}
          <div className={styles.info_detail}>
            <img src={customerService} alt="" />
            <p>
              <strong>Customer Service</strong>
              <br></br>
              1-800-88-4688
            </p>
          </div>

          {/* fax */}
          <div className={styles.info_detail}>
            <img src={fax} alt="" />
            <p>
              <strong>Fax</strong>
              <br></br>
              +603-5121 4386
            </p>
          </div>

          {/* email */}
          <div className={styles.info_detail}>
            <img src={email} alt="" />
            <p>
              <strong>Email</strong>
              <br></br>
              contact@bodyfriend.com.my
            </p>
          </div>
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          <h2>Contact Us</h2>
          <p className={styles.formDescription}>
            Feel free to write to us if you need more information about our
            services, products, or business-related inquiries.
          </p>
          <div className={styles.formRow}>
            <select
              className={styles.selectField}
              name="title"
              onChange={handleChange}
            >
              <option value="Mr">Mr</option>
              <option value="Ms">Ms</option>
            </select>
            <input
              className={styles.inputField}
              type="text"
              name="fullName"
              placeholder="Full Name"
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.formRow}>
            <input
              className={styles.inputField}
              type="text"
              name="contactNumber"
              placeholder="Contact Number"
              onChange={handleChange}
              required
            />
            <input
              className={styles.inputField}
              type="email"
              name="email"
              placeholder="Email Address"
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.formRow}>
            <input
              className={styles.inputField}
              type="text"
              name="state"
              placeholder="State"
              onChange={handleChange}
              required
            />
            <input
              className={styles.inputField}
              type="text"
              name="postcode"
              placeholder="Postcode"
              onChange={handleChange}
              required
            />
          </div>
          <select
            className={styles.selectField}
            name="inquiryType"
            onChange={handleChange}
            required
          >
            <option value="">Type of Inquiry*</option>
            <option value="Product">Product</option>
            <option value="Service">Service</option>
          </select>
          <textarea
            className={styles.textareaField}
            name="description"
            placeholder="Description"
            onChange={handleChange}
            required
          ></textarea>
          <button className={styles.submitBtn} type="submit">
            Submit
          </button>
        </form>
      </div>

      {/* Success message modal */}
      {messageVisible && (
        <div className={styles.success_modal}>
          <p>Your inquiry has been submitted!</p>
          <div className={styles.loading_message}>
            <div className={styles.spinner}></div>
            <p>Refreshing the page...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUsMain;
